// extracted by mini-css-extract-plugin
module.exports = {"loading-text":"loading-text__cbWPw","popup":"popup__YYTiJ"};